import * as React from 'react';
import PlatformConditional from 'Components/PlatformConditional';
import DEXAHistory from './DEXA';
import CMAPHistory from './CMAP';
import MuscleImagingHistory from './MuscleImaging';
import EchocardiographyHistory from './Echocardiography';
import ScoliosisHistory from './Scoliosis';
import PelvisHistory from './Pelvis';
import MriHistory from './Mri';
import ScintigraphyHistory from './Scintigraphy';
import TTHistory from './TT';
import ThymusCTHistory from './ThymusCT';
import ThymusMRIHistory from './ThymusMRI';
import { filterByDocumentType } from 'Utility/documentHandling';
import type { TImagingDocumentType } from '../../utils';
import NerveUltrasoundHistory from './NerveUltrasound';

const History = ({ documents, startEdit }: IImagingHistory): React.JSX.Element => {
  const DEXADocs = filterByDocumentType(documents, 'dexa');
  const CMAPDocs = filterByDocumentType(documents, 'cmap');
  const MuscleImagingDocs = filterByDocumentType(documents, 'muscleImaging');
  const EchocardiographyDocs = filterByDocumentType(documents, 'echocardiography');
  const ScoliosisDocs = filterByDocumentType(documents, 'scoliosis');
  const PelvisDocs = filterByDocumentType(documents, 'pelvis');
  const MRIDocs = filterByDocumentType(documents, 'mri');
  const TTDocs = filterByDocumentType(documents, 'tt');
  const ScintigraphyDocs = filterByDocumentType(documents, 'scintigraphy');
  const ThymusCTDocs = filterByDocumentType(documents, 'thymusCt');
  const ThymusMRIDocs = filterByDocumentType(documents, 'thymusMri');
  const nerveUltrasoundDocs = filterByDocumentType(documents, 'nerveUltrasound');

  return (
    <React.Fragment>
      <PlatformConditional platform={['sma', 'dmd']}>
        <React.Fragment>
          <DEXAHistory documents={DEXADocs} startEdit={startEdit} />
          <CMAPHistory documents={CMAPDocs} startEdit={startEdit} />
          <MuscleImagingHistory documents={MuscleImagingDocs} startEdit={startEdit} />
        </React.Fragment>
      </PlatformConditional>

      <PlatformConditional platform="dmd">
        <EchocardiographyHistory documents={EchocardiographyDocs} startEdit={startEdit} />
      </PlatformConditional>

      <PlatformConditional platform={['sma', 'dmd']}>
        <React.Fragment>
          <ScoliosisHistory documents={ScoliosisDocs} startEdit={startEdit} />
          <PelvisHistory documents={PelvisDocs} startEdit={startEdit} />
        </React.Fragment>
      </PlatformConditional>

      <PlatformConditional platform={['sma', 'ms', 'parkinson']}>
        <MriHistory documents={MRIDocs} startEdit={startEdit} />
      </PlatformConditional>

      <PlatformConditional platform="parkinson">
        <React.Fragment>
          <TTHistory documents={TTDocs} startEdit={startEdit} />
          <ScintigraphyHistory documents={ScintigraphyDocs} startEdit={startEdit} />
        </React.Fragment>
      </PlatformConditional>

      <PlatformConditional platform="ninmt">
        <React.Fragment>
          <MriHistory documents={MRIDocs} startEdit={startEdit} />
        </React.Fragment>
      </PlatformConditional>

      <PlatformConditional platform="mgravis">
        <React.Fragment>
          <ThymusCTHistory documents={ThymusCTDocs} startEdit={startEdit} />
          <ThymusMRIHistory documents={ThymusMRIDocs} startEdit={startEdit} />
        </React.Fragment>
      </PlatformConditional>

      <PlatformConditional platform="polyneuro">
        <React.Fragment>
          <MriHistory documents={MRIDocs} startEdit={startEdit} />
          <NerveUltrasoundHistory documents={nerveUltrasoundDocs} startEdit={startEdit} />
        </React.Fragment>
      </PlatformConditional>
    </React.Fragment>
  );
};

interface IImagingHistory {
  documents: Array<IDocumentWithTypeV2<TImagingDocumentType>>;
  startEdit: StartEdit;
}

export default History;
